/**
 * @param  url
 * @param  data
 * @param  success
 * @return void
 */
$.postJSON = function (url, data, success) {
    var callback = function (json) {
            if (success && typeof success === "function") {
                success.call(this, json);
            }
        },
        dt = new Date(),
        tm = (dt.getTime() / 1000) - dt.getTimezoneOffset() * 60;

    if (typeof data === "object") {
        data = $.extend({tm: tm}, data);
    }
    else if (typeof data === "string") {
        data += (data ? "&" : "?") + "tm=" + tm;
    }

    $.post(url, data, callback, "json");
};